import * as firebase from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAu_m89Vuzd4vP1FwfiX6HiaAWIyOtjeYo",
    authDomain: "thezimble.firebaseapp.com",
    databaseURL: "https://thezimble.firebaseio.com",
    projectId: "thezimble",
    storageBucket: "thezimble.appspot.com",
    messagingSenderId: "37129867797",
    appId: "1:37129867797:web:05203ccf4576b3ca45341c",
    measurementId: "G-7RB2XKL2ZX"
};

firebase.initializeApp(firebaseConfig);